// extracted by css-extract-rspack-plugin
export default {"page":"styles-module__page__GcIH7","subnav":"styles-module__subnav__jKUp9","SubNavSpacer":"styles-module__SubNavSpacer__f1zmQ"};